// extracted by mini-css-extract-plugin
module.exports = {"btn":"exitedUserScreen_btn__3bjmB"};